module.exports = __webpack_public_path__ + "img/ImportStudent1.ec7d34f9.png";